import styled, { css } from 'styled-components';
import Padding from 'gatsby-theme-pagebuilder/src/components/section/padding';

export default styled(Padding)`
  ${({ $padding }) => $padding === 'extreme' && css`
    padding: 13.35rem 0;
  `}
`;
